/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LedgerOwnerType } from './LedgerOwnerType';
import {
    LedgerOwnerTypeFromJSON,
    LedgerOwnerTypeFromJSONTyped,
    LedgerOwnerTypeToJSON,
    LedgerOwnerTypeToJSONTyped,
} from './LedgerOwnerType';

/**
 * 
 * @export
 * @interface LedgerOwner
 */
export interface LedgerOwner {
    /**
     * 
     * @type {LedgerOwnerType}
     * @memberof LedgerOwner
     */
    ownerType: LedgerOwnerType;
    /**
     * Absent for PLATFORM.
     * @type {string}
     * @memberof LedgerOwner
     */
    ownerId?: string;
}



/**
 * Check if a given object implements the LedgerOwner interface.
 */
export function instanceOfLedgerOwner(value: object): value is LedgerOwner {
    if (!('ownerType' in value) || value['ownerType'] === undefined) return false;
    return true;
}

export function LedgerOwnerFromJSON(json: any): LedgerOwner {
    return LedgerOwnerFromJSONTyped(json, false);
}

export function LedgerOwnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): LedgerOwner {
    if (json == null) {
        return json;
    }
    return {
        
        'ownerType': LedgerOwnerTypeFromJSON(json['ownerType']),
        'ownerId': json['ownerId'] == null ? undefined : json['ownerId'],
    };
}

export function LedgerOwnerToJSON(json: any): LedgerOwner {
    return LedgerOwnerToJSONTyped(json, false);
}

export function LedgerOwnerToJSONTyped(value?: LedgerOwner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ownerType': LedgerOwnerTypeToJSON(value['ownerType']),
        'ownerId': value['ownerId'],
    };
}

